import React from "react"
import NoteBuilder from "../../NoteBuilder/NoteBuilder"
import clsx from 'clsx'

class ProductFolioItemBuilderNotes extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    // console.log("NOTES", this.props.service_log_notes_path)
    var tabClasses = clsx({
      'active': this.props.active_tab == "folio-item-notes",
      'tab-pane': true
    });


    return(
      <div className={tabClasses} id="folio-item-notes">

        <NoteBuilder namespace="product_folio_item" new_record={true} note={this.props.note_obj} onChangeNote={this.props.onChangeNote} onChangeImageGroup={this.props.onChangeImageGroup} onChangeFlagged={this.props.onChangeFlagged} buttons={this.props.buttons} />
      </div>
    )

  }
}

export default ProductFolioItemBuilderNotes
